
import MD5 from 'md5.js';

export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    privacyInHtml: '',
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    cDoNotShowPrivacyAgain: {
      get() {
        const usernamesJsonStr = localStorage.doNotShowPrivacy || '[]';
        const usernames = JSON.parse(usernamesJsonStr);
        const md5username = new MD5()
          .update(this.$store.state.app.userName)
          .digest('hex');
        return usernames.includes(md5username);
      },
      set(_value) {},
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.$axios.$get('/api/privacy').then((response) => {
          this.privacyInHtml = response;
        });
      }
    },
  },
  methods: {
    clickDoNotShowPrivacyAgain(val) {
      const usernamesJsonStr = localStorage.doNotShowPrivacy || '[]';
      const usernames = JSON.parse(usernamesJsonStr);
      const currentUserName = new MD5()
        .update(this.$store.state.app.userName)
        .digest('hex');
      if (val) {
        if (!usernames.includes(currentUserName)) {
          usernames.push(currentUserName);
          localStorage.setItem('doNotShowPrivacy', JSON.stringify(usernames));
        }
      } else if (usernames.includes(currentUserName)) {
        localStorage.setItem(
          'doNotShowPrivacy',
          JSON.stringify(usernames.filter((item) => item !== currentUserName))
        );
      }
    },
  },
};
